import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryBtn } from '../Assets/Buttons';
import { Field, Label } from '../Assets/Fieldset';
import { Input } from '../Assets/Input';
import { Text, TextLink } from '../Assets/Text';
import { Heading } from '../Assets/Heading';
import { useSignInMutation } from '../../services/api/userApi';

const SignInForm = () => {
    const [signIn, { data: signInData, isLoading: isSigningIn, isError: isSignInError, error: signInError }] = useSignInMutation();
    const navigate = useNavigate();
    const [username, setFormUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errs, setErrs] = useState("");
    const [validated, setValidated] = useState(false);
  
    const validateForm = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            handleSubmit(event);
        }
        setValidated(true);
    };

    const handleSubmit = async(event) => {
        event.preventDefault();
    
        try{
            const result = await signIn({ username, password }).unwrap();
            if (result.ok) {
                navigate('/upcoming-games');
            } else {
                setErrs(result.error);
            }
        } catch (error) {
            if (error.data.error.includes("NotAuthorizedException: Incorrect username or password.")) {
                setErrs("Incorrect username or password.");
            } else {
                setErrs("Login failed. Please check your credentials and try again.");
            }
        };
    };

    return (
        <form onSubmit={validateForm} className="grid w-full max-w-sm grid-cols-1 gap-6" noValidate>
            <Heading>Sign in to your account</Heading>
        
            <Field>
                <Label>Username</Label>
                <Input 
                    type="text"
                    value={username}
                    onChange={(e) => setFormUsername(e.target.value)}
                    minLength={4}
                    required
                    aria-invalid={username.length < 4 && validated ? "true" : "false"}
                />
                {username.length < 4 && validated && (
                <Text className="text-brand-red-500 text-sm mt-1">Username must be at least 4 characters.</Text>
                )}
            </Field>
        
            <Field>
                <Label>Password</Label>
                <Input 
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    aria-invalid={password === "" && validated ? "true" : "false"}
                />
                {password === "" && validated && (
                    <Text className="text-brand-red-500 text-sm mt-1">Please enter your password.</Text>
                )}
            </Field>
        
            <div className="flex items-center justify-end">
                <TextLink href="/resetpassword" className="text-sm">
                    Forgot password?
                </TextLink>
            </div>
        
            {errs && (
                <Text className="text-brand-red-500">{errs}</Text>
            )}
        
            <PrimaryBtn type="submit" className="w-full">
                Sign in
            </PrimaryBtn>
        
            <Text>
                Don't have an account?{' '}
                <TextLink href="/signup">Create one</TextLink>
            </Text>
        </form>
    );
};

export default SignInForm;